export default function createHelpers({ history }) {
  return {
    history,
  };
}
